import type { DeploymentState } from "@/types";
import { DEP_STATE_FLOW } from "@/data/mock";
import { cn } from "@/lib/utils";

export function StateMachine({ current }: { current: DeploymentState }) {
  const idx = DEP_STATE_FLOW.indexOf(current);
  return (
    <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[11px]" aria-label="Deployment state machine">
      {DEP_STATE_FLOW.map((s, i) => (
        <span key={s} className="flex items-center gap-x-1.5">
          <span
            className={cn(
              "whitespace-nowrap",
              i === idx ? "font-semibold text-primary" : "font-normal text-muted"
            )}
          >
            {s}
          </span>
          {i < DEP_STATE_FLOW.length - 1 && (
            <span aria-hidden className="text-subtle">
              →
            </span>
          )}
        </span>
      ))}
    </div>
  );
}